import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "@artprov/design-system";
import { FeedbackModal } from "./FeedbackModal.jsx";

/**
 * @typedef {Object} NuevaSolicitudModalProps
 * @property {boolean} openMessagesModal - Indica si el modal está abierto.
 * @property {function} setOpenMessagesModal - Función para cambiar el estado del modal.
 * @property {function} setIsSuccessEnvioSolicitud - Función para cambiar el estado del envio de una solicitud.
 * @property {function} onCancel - Función para cambiar el estado del modal
 * @property {function} onAccept - Función que desencadena el envio de solicitud o la redireccion hacia MisSolictudes
 * @param {string} [props.title] - The title of the modal.
 * @param {string} [props.message] - The message of the modal.
 * @param {string} [props.variant] - The variant of the modal. Warning | Success | Error
 */

/**
 * Componente para mostrar el modal de Warning y Success cuando se envia una solicitud con sus comprobantes
 * @param {MessagesModal} props
 */

const Buttons = ({ onAccept, labelAccept, onCancel, labelCancel = "" }) => labelCancel === '' ?
  (<Modal.AcceptButton onClick={onAccept}>{labelAccept}</Modal.AcceptButton>) :
  (<>
    <Modal.CancelButton onClick={() => { onCancel(false) }} className='h-9'>{labelCancel}</Modal.CancelButton>
    <Modal.AcceptButton onClick={onAccept}>{labelAccept}</Modal.AcceptButton>
  </>)

export const MessagesModal = ({
  openMessagesModal,
  setOpenMessagesModal,
  isSuccessEnvioSolicitud,
  title,
  message,
  variant,
  labelAccept,
  labelCancel,
  onAccept,
  size,
}) => {
  const navigate = useNavigate();

  return (
    <FeedbackModal
      open={openMessagesModal}
      setOpen={setOpenMessagesModal}
      variant={variant}
      title={title}
      message={message}
      labelAccept={labelAccept}
      labelCancel={labelCancel}
      onIconClose={() => {
        setOpenMessagesModal(false);
        if (isSuccessEnvioSolicitud)
          navigate(`/`);
      }}
      onAccept={onAccept}
      className={size}
      classNameFooter={variant == "success" ? "w-[100%] pb-2 mt-[1.25rem]  " : ""}>
      <Buttons
        onAccept={onAccept}
        labelAccept={labelAccept}
        labelCancel={labelCancel}
        onCancel={setOpenMessagesModal}
      />
    </FeedbackModal>
  );

};